'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var reactToastify = require('react-toastify');
require('react-toastify/dist/ReactToastify.css');
var classNames = require('classnames/bind');
var Icon = require('../Icon/Icon.js');
require('./ToastOverload.scss.js');
var Toast_module = require('./Toast.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cx = classNames__default["default"].bind(Toast_module["default"]);
var ToastIcon = Object.freeze({
    success: jsxRuntime.jsx(Icon["default"], { name: "CheckmarkCircle", className: Toast_module["default"].icon }),
    danger: jsxRuntime.jsx(Icon["default"], { name: "AlertCircleFill", className: Toast_module["default"].icon }),
    warning: jsxRuntime.jsx(Icon["default"], { name: "AlertCircle", className: Toast_module["default"].icon }),
    info: jsxRuntime.jsx(Icon["default"], { name: "InfoCircle", className: Toast_module["default"].icon }),
});
var DEFAULT_DISPLAY_DURATION = 5000;
var toast = function (_a) {
    var variant = _a.variant, message = _a.message, buttonText = _a.buttonText, buttonAction = _a.buttonAction, options = _a.options;
    var defaultOptions = _tslib.__assign({ hideProgressBar: true, autoClose: DEFAULT_DISPLAY_DURATION, closeButton: false, closeOnClick: false }, options);
    var toastClassname = cx({
        toastBodyContainer: true,
        successToast: variant && variant.includes('success'),
        dangerToast: variant && variant.includes('danger'),
        warningToast: variant && variant.includes('warning'),
        infoToast: variant && variant.includes('info'),
    });
    var GenericToast = function (_a) {
        var toastId = _a.toastId;
        var tId = toastId.toString();
        var containerRef = React.createRef();
        var dismissToast = function () {
            reactToastify.toast.dismiss(toastId);
        };
        var handleCloseKeyUp = function (_a) {
            var key = _a.key;
            if (key === 'Enter') {
                dismissToast();
            }
        };
        return (jsxRuntime.jsxs("div", _tslib.__assign({ ref: containerRef, id: tId, className: Toast_module["default"].toastRow }, { children: [ToastIcon[variant], jsxRuntime.jsxs("div", _tslib.__assign({ className: Toast_module["default"].toastRowMiddle }, { children: [jsxRuntime.jsx("p", _tslib.__assign({ className: Toast_module["default"].toastRowMessage }, { children: message })), buttonText && buttonAction && (jsxRuntime.jsx("button", _tslib.__assign({ type: "button", className: Toast_module["default"].toastRowBtn, onClick: buttonAction }, { children: buttonText })))] })), jsxRuntime.jsx("span", _tslib.__assign({ className: Toast_module["default"].closeBtn, tabIndex: 0, onClick: dismissToast, onKeyUp: handleCloseKeyUp, role: "button" }, { children: jsxRuntime.jsx(Icon["default"], { name: "Close" }) }))] })));
    };
    return reactToastify.toast(function (_a) {
        var toastProps = _a.toastProps;
        return jsxRuntime.jsx(GenericToast, { toastId: toastProps.toastId });
    }, _tslib.__assign(_tslib.__assign({}, defaultOptions), { className: toastClassname }));
};

exports["default"] = toast;
//# sourceMappingURL=Toast.js.map
